export enum Entrepreneur {
  No = 'No',
  Freelancer = 'Freelancer',
  BusinessOwner = 'BusinessOwner',
}

export enum EntrepreneurLabel {
  No = 'Non',
  Freelancer = 'Travailleur indépendant',
  BusinessOwner = "Chef d'entreprise",
}
